import { Observable } from 'rxjs';
import { MarketplaceParameter } from 'src/app/global/interfaces/marketplace-parameter';
import { Product } from '../components/shopping-cart/product';

export abstract class CarroComprasService {
  mostrarCarro$: Observable<boolean>;
  products$: Observable<Product[]>;
  changeCantidad$: Observable<boolean>;
  changeValorCantidad$: Observable<number>;
  retoma$: Observable<boolean>;
  changePaso$: Observable<string>;
  aplicarDescuento$: Observable<any>;
  removerDescuento$: Observable<boolean>;

  carroCompraVacio: boolean;

  abstract get products(): Product[];
  abstract set products(products: Product[]);

  abstract toogle(): void;

  abstract show(): void;

  abstract hide(): void;

  abstract loadFromUrl(): MarketplaceParameter;

  abstract getProductsEncoded(): string;

  abstract getCurrentProduct(): Product;

  abstract removeProduct(product: Product): void;

  abstract changeCantidad(cambio: boolean): void;

  abstract changeValorCantidad(valor: number): void;

  abstract changeRetoma(value: boolean): void;

  abstract getRetoma(): boolean;

  abstract changePaso(paso: string): void;

  abstract aplicarDescuento(descuento: any): void;

  abstract removerCodigoDescuento(): void;

  abstract getCodigoDescuento(): string;
}
